import createModel from 'utils/model'
import {currentTree, departments} from 'services/departments'

export default createModel({
    namespace: 'departments',
    state: {},
    subscriptions: {},
    effects: {
        *currentTree({payload}, {call}) {
            return yield call(currentTree, payload)
        },

        *getDepartments({payload}, {call}) {
            return yield call(departments, payload)
        },
    },

    reducers: {
        setProperty(state, action) {
            return {...state, ...action.payload}
        },
    },
})
